import digitalFormsExperience from './digital-forms-experience.json';

export default {
  'digital-forms-experience': digitalFormsExperience,
};
